import { numberToCurrency } from "helpers/string"
import PropTypes from "prop-types"
import pluralize from "pluralize"
import React, { memo } from "react"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"

import { useTranslation } from "react-i18next"

const TotalPrice = ({ tripTitle, calculation, className, edit }) => {
  const { t } = useTranslation()

  const specificBooking = useSelector(modelSelector("booking"))
  const trip = useSelector(modelSelector("trip"))
  const booking = specificBooking.id || !trip.existing_draft_booking ? specificBooking : trip.existing_draft_booking
  const classes = ["hstack gap-10 justify-content-between align-items-start"]
  const isFlatRate = booking.pricing_type === "charge_flat_rate"

  const baseAmount = isFlatRate || edit ? booking?.base_price : calculation.subtotal
  const feeAmount = isFlatRate || edit ? booking?.booking_fee : calculation.taxesAndFees
  const totalAmount = isFlatRate || edit ? booking?.total_amount : calculation.totalPrice

  if (!calculation.pricingType) return null

  return (
    <div className={className}>
      <div className={classes.join(" ")}>
        <div>
          <p className="mt-1 mb-0">{tripTitle}</p>
          <p className="fs-7 lh-1 text-gray-light m-0">
            <small>
              {t(`booking.calculation.total.${calculation.pricingType}`, {
                minimumPrice: numberToCurrency(calculation.minimumRate),
                minimumPersons: pluralize("person", calculation.minimumPersons, true),
                pricePerPerson: numberToCurrency(calculation.pricePerPerson)
              })}
            </small>
          </p>
        </div>
        <div>
          <p className="lh-1 mb-0">{numberToCurrency(baseAmount)}</p>
          <p className="fs-7 lh-1 text-gray-light text-end m-0">{/* <small>incl. tax</small> */}</p>
        </div>
      </div>
      {!edit && calculation.addOnsTotal > 0 && (
        <div className="justify-between align-center">
          <p className="mt-1 mb-0">{t("booking.calculation.add_ons", { defaultValue: "Add-ons" })}</p>
          <p className="mb-0">{numberToCurrency(calculation.addOnsTotal)}</p>
        </div>
      )}
      <div className="justify-between align-center">
        <p className="mt-1 mb-0">{t("booking.calculation.fees")}</p>
        <p className="mb-0">{numberToCurrency(feeAmount)}</p>
      </div>
      <br />
      <div className="justify-between align-center">
        <p className="h3 fw-bold lh-1 mb-0">{t("booking.calculation.total_label")}</p>
        <p className="h3 fw-bold lh-1 mb-0">{numberToCurrency(totalAmount)}</p>
      </div>
    </div>
  )
}

TotalPrice.propTypes = {
  calculation: PropTypes.shape({
    pricingType: PropTypes.string.isRequired,
    minimumRate: PropTypes.number.isRequired,
    minimumPersons: PropTypes.number.isRequired,
    pricePerPerson: PropTypes.number.isRequired,
    totalPrice: PropTypes.number.isRequired,
    subtotal: PropTypes.number.isRequired,
    taxesAndFees: PropTypes.number.isRequired,
    addOnsTotal: PropTypes.number
  }).isRequired,
  className: PropTypes.string,
  tripTitle: PropTypes.string,
  edit: PropTypes.bool
}

export default memo(TotalPrice)
